import { colors, size, typography } from '@everlywell/leaves';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  margin-bottom: ${size.xl1}px;
`;

const Title = styled.div`
  width: 100%;
  margin-bottom: ${size.xl2}px;
  ${typography.h4Text};
`;

const Description = styled.div`
  width: 100%;
  ${typography.bodyText};

  a {
    font-weight: ${typography.weight.bold};
    color: ${colors.green5};
  }

  ul,
  ol {
    list-style-position: inside;
    padding-left: ${size.lg}px;
    margin: ${size.lg}px 0;

    li {
      margin: ${size.md}px 0;
    }
  }
`;

export { Container, Title, Description };
